export const messages = {
  title: {
    id: 'admin/promotions.form.more-for-less.title',
  },
  trigger: {
    description: {
      id: 'admin/promotions.form.more-for-less.editor.trigger.description',
    },
    quantityPlaceholder: {
      id: 'admin/promotions.form.more-for-less.quantity.placeholder',
    },
    minQuantityAriaLabel: {
      id: 'admin/promotions.form.more-for-less.editor.trigger.min-quantity.aria',
    },
    validation: {
      greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
      required: {
        id: 'admin/promotions.form.skus-collections.validation.required',
      },
    },
  },
}
